import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Space } from "antd";
import { LogoIcon } from "assets/icons";
import { forgotPassword } from "stores/slices/auth";

import AppButton from "components/button";
import ForgotPasswordForm from "components/forms/forgotPasswordForm";

import styles from "./styles.module.scss";

const forgotPasswordPage = () => {
  const dispath = useDispatch();

  const navigate = useNavigate();

  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const [isForgotSuccess, setForgotSuccess] = useState(false);

  const handleSubmit = async values => {
    setLoading(true);

    const { payload } = await dispath(forgotPassword(values));

    if (payload && payload.status === 200) {
      setForgotSuccess(true);
    }

    setLoading(false);
  };

  const handleBackToSignIn = () => {
    navigate("/auth/sign-in");
  };

  return (
    <div className={styles.authPage}>
      <div className={styles.authContent}>
        <div className={styles.authLogo}>
          <LogoIcon />
        </div>
        <div className={styles.authForm}>
          {!isForgotSuccess && (
            <>
              <div style={{ marginBottom: 16, textAlign: "center" }}>
                <span>{t("label.forgotPasswordMsg")}</span>
              </div>
              <ForgotPasswordForm onSubmit={handleSubmit} loading={loading} />
              <Space
                direction="horizontal"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: 20,
                }}
              >
                <span>{`${t("label.backToSignInMessage")}`}</span>
                <Link
                  to="/auth/sign-in"
                  style={{
                    fontWeight: 700,
                    pointerEvents: loading ? "none" : "auto",
                  }}
                >
                  {t("label.signIn")}
                </Link>
              </Space>
            </>
          )}
          {isForgotSuccess && (
            <div style={{ textAlign: "center" }}>
              <h1>{t("text.forgotPasswordSuccessTitle")}</h1>
              <p>{t("text.forgotPasswordSuccessMsg")}</p>
              <AppButton
                label={t("label.backToSignIn")}
                color={"primary"}
                type="submit"
                onClick={handleBackToSignIn}
                className="authButton"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default forgotPasswordPage;
